import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './config/axiosConfig'; // B-12 Phase 3 — withCredentials global pour cookie auth
import './config/fetchCsrfPatch'; // B-12 Phase 5 — injection auto du header X-CSRF-Token sur window.fetch
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import ImpersonateBanner from './components/ImpersonateBanner';
import { AuthProvider } from './contexts/AuthContext';
import { ClickTrackingProvider } from './contexts/ClickTrackingContext';
import { Toaster } from './components/ui/sonner';
import { useKlarysOuvert } from './components/klarys/useKlarysOuvert';
import AppRoutes from './components/AppRoutes';
import PublicPageMetadata from './components/PublicPageMetadata';
import CookieConsent from './components/CookieConsent';
import { KlarysLauncher } from './components/klarys/KlarysLauncher';

const ToasterAdaptatif = () => { const k = useKlarysOuvert(); return <Toaster position={k ? 'bottom-left' : 'top-right'} offset={k ? '72px' : undefined} />; };

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <ClickTrackingProvider>
            <Router basename={window.location.pathname.match(/^\/proxy\/\d+/)?.[0] || undefined}>
              <div className="App dark:bg-slate-900 dark:text-white min-h-screen transition-colors duration-300">
                <ImpersonateBanner />
                <ToasterAdaptatif />
                <PublicPageMetadata />
                <AppRoutes />
                <KlarysLauncher />
                <CookieConsent />
              </div>
            </Router>
          </ClickTrackingProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
